import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DialogModule} from "primeng/dialog";
import {PdfJsViewerModule} from "ng2-pdfjs-viewer";
import {SharedModule} from "../../shared.module";
import {ViewerInterface} from "../../interfaces/viewer-interface";
import {ProyectoService} from "../../../users/proyectos/services/proyecto.service";
import {TramiteService} from "../../../users/tramites/services/tramite.service";
import {LoginServices} from "../../../auth/login/services/login.service";

@Component({
  selector: 'app-viewer-pdf',
  standalone: true,
    imports: [
        DialogModule,
        PdfJsViewerModule,
        SharedModule
    ],
  templateUrl: './viewer-pdf.component.html',
  styleUrl: './viewer-pdf.component.scss'
})
export class ViewerPdfComponent implements OnInit{
    @Input() _showLoader: boolean = false
    @Input() dialogPdfView = false;
    @Input() viewer!:ViewerInterface;
    @Output() onPdfEmitterClose = new EventEmitter<boolean>;
    @ViewChild('viewer', {static: false}) public embeddedPdfViewer: { pdfSrc: string; downloadFileName: string; } | any;
    onPdfError = new EventEmitter<string>();
    onPdfLoadSuccess = new EventEmitter<void>();
    zoom = 'auto';
    pdfSrc: string = '';
    fileName: string = '';
    constructor(private proyectoServices: ProyectoService, public tramite: TramiteService, public loginServices: LoginServices) {
    }
    ngOnInit(): void {
        this.openFileInViewer(this.viewer.hash!,this.viewer.nombre!);
    }

    openFileInViewer(hash: string, fileName: string) {
            this.fileName = fileName;
            this.pdfSrc = new URL(this.proyectoServices.getSrcFile(hash, 'inline')).toString(); //obtener la ruta para visualizar
            this.dialogPdfView = true;
            this._showLoader = true
            setTimeout(() => {
                if (this._showLoader) {
                    this._showLoader = false
                }
            }, 600);
    }

    initializePdfViewer() {
        if (this.embeddedPdfViewer) {
            this._showLoader = true;
            this.embeddedPdfViewer.refresh();
        }
    }

    closeViewerPdf(){
        this.dialogPdfView=false;
        this.onPdfEmitterClose.emit(false);
    }

    pdfLoaded(event: any) {
        if (event) {
            this._showLoader = false;
            console.log('PDF cargado correctamente');
            this.onPdfLoadSuccess.emit();
        }
    }
    pdfError(event: any) {
        console.error("Error al cargar el PDF:", event);
        this._showLoader = false;
        this.onPdfError.emit("Error al cargar el archivo PDF.");
    }


}
